/**
 * @example
 * // returns 'corn:claims:claim:223SSU6SKL'
 * makeCorn({
 *   serviceName: 'claims',
 *   resourceType: 'claim',
 *   resourceId: '223SSU6SKL',
 * })
 *
 * // with wrapper function
 * const makeClaimCorn = (claimNumber: string) => makeCorn({
 *     serviceName: 'claims',
 *     resourceType: 'claim',
 *     resourceId: claimNumber,
 *   })
 * @param options.serviceName Name of service for corn (e.g. "claims")
 * @param options.resourceType Type of resource for corn (e.g. "claim")
 * @param options.resourceId Unique ID for resource, such as claim number, guid, etc
 * @returns Valid corn (e.g. "corn:claims:claim:223SSU6SKL")
 */
export function makeCorn({ serviceName, resourceType, resourceId, }) {
    return `corn:${serviceName}:${resourceType}:${resourceId}`;
}
